/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedHeadLinkTags_metadata$ref = any;
type SharedHeadMetaTags_metadata$ref = any;
type SharedHeadScriptTags_metadata$ref = any;
type SharedHeadTitleTag_metadata$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedHead_searchBrowse$ref: FragmentReference;
export type SbSharedHead_searchBrowse = {|
  +meta: ?{|
    +canonical: ?string,
    +prev: ?string,
    +disableIndexing: ?boolean,
    +$fragmentRefs: SharedHeadTitleTag_metadata$ref & SharedHeadMetaTags_metadata$ref & SharedHeadLinkTags_metadata$ref & SharedHeadScriptTags_metadata$ref,
  |},
  +languageAnnotations: ?$ReadOnlyArray<?{|
    +href: ?string,
    +hrefLang: ?string,
    +available: ?boolean,
  |}>,
  +pageType: ?string,
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +photos: ?$ReadOnlyArray<?{|
        +versions: ?$ReadOnlyArray<?{|
          +webPath: ?string
        |}>
      |}>
    |}
  |}>,
  +$refType: SbSharedHead_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedHead_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canonical",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prev",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "disableIndexing",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadTitleTag_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadMetaTags_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadLinkTags_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadScriptTags_metadata",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "languageAnnotations",
      "storageKey": null,
      "args": null,
      "concreteType": "LanguageAnnotations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "href",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hrefLang",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "available",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photos",
              "storageKey": "photos(limit:1,skipImageService:true)",
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 1,
                  "type": "Int"
                },
                {
                  "kind": "Literal",
                  "name": "skipImageService",
                  "value": true,
                  "type": "Boolean"
                }
              ],
              "concreteType": "ItemPhoto",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "versions",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPhotoVersion",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "webPath",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f0d4ad6f0607c74b7be76566549c9c37';
module.exports = node;
